/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CostExcludingTaxesResource
 */
export interface CostExcludingTaxesResource {
    /**
     * 
     * @type {number}
     * @memberof CostExcludingTaxesResource
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof CostExcludingTaxesResource
     */
    currency: CostExcludingTaxesResourceCurrencyEnum;
}


/**
 * @export
 */
export const CostExcludingTaxesResourceCurrencyEnum = {
    Eur: 'EUR',
    Gbp: 'GBP',
    Usd: 'USD'
} as const;
export type CostExcludingTaxesResourceCurrencyEnum = typeof CostExcludingTaxesResourceCurrencyEnum[keyof typeof CostExcludingTaxesResourceCurrencyEnum];


/**
 * Check if a given object implements the CostExcludingTaxesResource interface.
 */
export function instanceOfCostExcludingTaxesResource(value: object): value is CostExcludingTaxesResource {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function CostExcludingTaxesResourceFromJSON(json: any): CostExcludingTaxesResource {
    return CostExcludingTaxesResourceFromJSONTyped(json, false);
}

export function CostExcludingTaxesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostExcludingTaxesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': json['currency'],
    };
}

export function CostExcludingTaxesResourceToJSON(value?: CostExcludingTaxesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'currency': value['currency'],
    };
}

